import { application } from "./application";

const controllers = import.meta.glob("./**/*_controller.js", { eager: true });

for (let path in controllers) {
  const name = path
    .replace("./", "")
    .replace("_controller.js", "")
    .replaceAll("/", "--")
    .replaceAll("_", "-");
  const module = controllers[path];
  const controller = module.default;

  if (!controller) {
    console.error(`No default export from ${path}`);
    continue;
  }

  console.log(`Registering controller: ${name} from ${path}`);
  application.register(name, controller);
}
